import { render, staticRenderFns } from "./Sincronizar.vue?vue&type=template&id=771c0571"
import script from "./Sincronizar.vue?vue&type=script&lang=js"
export * from "./Sincronizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports